const url = window.location.hostname;
export const translation = {
  zenit: {
    en: {
      siteTitle: "Champions Series",
      rulesBtnText: "Rules",
      title: `Champions Series`,
      subtitle: "Anyone can win",
      subtitlebig: "$65,000 at stake",
      button: "START",
      stepTitle1: 'STEP 1',
      stepText1: 'Register',
      step1Text1: ' or ',
      step1Span2: 'log in',
      step1Text4: ' on the site',
      stepTitle2: 'STEP 2',
      stepText2: `Place your bets\n
      for the\u00A0World\u00A0Cup`,
      stepTitle3: 'STEP 3',
      stepText3: `Go around rivals
            and win\u00A0freebies`,
      stepText1Mobile: 'on the site ',
      step1Span2Mobile: 'the PARTICIPATE button',
      stepText2Mobile: `Bet on the World Cup \xA0
      and beat your opponents`,
      stepText3Mobile: `Win a cool free bets`,
      bookmakerString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      supportText: "SUPPORT SERVICE:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: {
        main: "Terms and conditions of the Promotion\u00A0",
        span: "Champions Series"
      },
      level: "Level",
      totalPoints: "Total of points",
      prizeSum: "Prize amount",
      currency: 'Currency',
      place1: '1st place',
      place2: '2nd place',
      place3: '3rd place',
      dollar: 'Dollar',
      ruble: 'Ruble',
      hryvnia: 'Hryvnia',
      euro: 'Euro',
      tenge: 'Tenge',
      pmrRuble: 'PMR Ruble',
      moldovanLeu: 'Moldovan leu',
      azerbaijaniManat: 'Azerbaijani manat',
      tajikSomoni: 'Tajik Somoni',
      iranianRial: 'Iranian rial',
      brazilianReal: 'Brazilian real',
      turkmenManat: 'Turkmen Manat',
      uzbekSum: 'Uzbek sum',
      paragraph1: '1. The promotion runs from 11/20/2022 to 12/18/2022.',
      paragraph2: '2. The terms of the Promotion are set by Zenit betting company and can be changed at any time without giving any reasons or additional notifications.',
      paragraph31: '3. A participant must register or log in on the ' ,
      paragraph3url: ` ${url}\u00A0`,
      paragraph32: 'website during the period of the Promotion and confirm his/her participation in the Promotion by clicking on the "Participate" button',
      paragraph4: '4. During the period of the Promotion, the player receives points for bets. The following bets will count towards the Promotion, except bets on stats:   ',
      paragraph5: '5. For all bets from clause 4 the Participant receives daily points in the amount:',
      paragraph6: '6. Depending on the number of points earned, Participants are assigned one of 7 levels. The size of the prize depends on the level of the Participant. To get to the first level, the Participant must collect 100 or more points.',
      paragraph7: "7. At the end of the Promotion, Participants who have collected 100 points or more will be entitled to scroll through the randomiser once, except for the participants who will take places 1 to 3. The randomizer determines the amount of the Participant's free bet (from 0 to the maximum value on the level). Free Bets are awarded the day after the end of the Promotion (19.12.2022). ",
      paragraph8: '8. Participants who finish in 1st to 3rd place at the end of the promotion will receive fixed free bets: 3rd place - 1 100$, 2nd place - 1 600$, 1st place - from 2 400 to 3 200$ (if the amount of points is less than 2 400$, the amount of the free bet is 2 400$; if the amount of points is above 2 400$, the amount of the free bet equals the amount of points, but does not exceed 3 200$).',
      paragraph9: '9. Participants who have access to the randomizer can use it to determine their prize until December 20, 2022.',
      paragraph10: '10. If the Participants score the same number of points, priority in the table is given to the Participant whose betting amount during the Promotion period was higher. If the sum of bets is equal, the Participants share a place in the standings, but each Participant receives the prize corresponding to the place taken, in full.',
      paragraph11: '11. Free bets will be credited to Participants who have a confirmed phone number at the time of summing up the results of the action. Scrolling randomiser is also only available to Participants in the Promotion with a confirmed phone number. ',
      paragraph12: '12. Free bet can be used within 7 days (168 hours) from the moment of its crediting.',
      paragraph13: '13. Points for bets are not credited in the following cases:',
      paragraph14: "14. BC Zenit has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company's Promotions, invalidate any actions of a participant in respect of whom BC Zenit has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:",
      paragraph15: '15. In case of detection of any of the violations of the rules of the Promotion, BC Zenit has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.',
      paragraph16: '16. Terms of use of free bets:',
      paragraph17: '17. In case of winning a bet paid with the amount of the free bet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the free bet. The free bet is not reused.',
      paragraph18: '18. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph19: '19. By using the free bet option, the Participant fully agrees to these Terms and conditions.',
      subparagraph41: '4.1. Bets are placed on the 2022 World Cup:',
      subparagraph411: '- Football. World. World Cup-2022. Group stage. Qatar;',
      subparagraph412: '- Football. Results. World. World Cup-2022. Winner;',
      subparagraph413: '- Football. World. World Cup-2022. 1/8 final. Qatar;',
      subparagraph414: '- Football. World. World Cup-2022. 1/4 finals. Qatar;',
      subparagraph415: '- Football. World. World Cup-2022. 1/2 final. Qatar;',
      subparagraph416: '- Football. World. World Cup-2022.. Match for 3rd place. Qatar;',
      subparagraph417: '- Football. World. World Cup-2022.. Final. Qatar.',
      subparagraph42: '4.2. Single, accumulator and/or system bets, with all events in the accumulator and/or system coupon must be for the FIFA World Cup 2022.',
      subparagraph43: '4.3. Bets calculated during the period of the Promotion.',
      subparagraph44: '4.4. Bets calculated with the status of "lose" or "win".',
      subParagraph51: "5.1. Winning bet: the amount of net winnings (equivalent in rubles)*1%. \n",
      subParagraph52: "5.2. Losing bet: bet amount (equivalent in rubles)*5%.",
      tableCenterTopText5: "Level",
      tableRightTopText5:  'Сумма баллов',
      tableRightTr5: 'from 0 to 99',
      tableLeftTr52: '1.Beginner',
      tableRightTr52: 'from 100 to 999',
      tableLeftTr53: '2.Amateur',
      tableRightTr53: 'from 1000 to 4999',
      tableLeftTr54: '3.Talent',
      tableRightTr54: 'from 5000 to 9999',
      tableLeftTr55: '4.Pro',
      tableRightTr55: 'from 10000 to 19999',
      tableLeftTr56: '5.Master',
      tableRightTr56: 'from 20000 to 29999',
      tableLeftTr57: '6.Legend',
      tableRightTr57: 'from 30000 to 39999',
      tableLeftTr58: '7.Guru',
      tableRightTr58: 'from 40000',
      tableCenterTr621: 'to 1000',
      tableCenterTr622: 'to 5000',
      tableCenterTr623: 'to 10000',
      tableCenterTr624: 'to 20000',
      tableCenterTr625: 'to 30000',
      tableCenterTr626: 'to 40000',
      tableCenterTr627: 'to 50000',
      tableCenterTr631: 'to 16',
      tableCenterTr632: 'to 80',
      tableCenterTr633: 'to 160',
      tableCenterTr634: 'to 320',
      tableCenterTr635: 'to 490',
      tableCenterTr636: 'to 650',
      tableCenterTr637: 'to 800',
      tableCenterTr641: 'to 600',
      tableCenterTr642: 'to 3000',
      tableCenterTr643: 'to 6000',
      tableCenterTr644: 'to 12000',
      tableCenterTr645: 'to 18000',
      tableCenterTr646: 'to 24000',
      tableCenterTr647: 'to 30000',
      tableCenterTr651: 'to 17',
      tableCenterTr652: 'to 82',
      tableCenterTr653: 'to 170',
      tableCenterTr654: 'to 330',
      tableCenterTr655: 'to 500',
      tableCenterTr656: 'to 670',
      tableCenterTr657: 'to 840',
      tableCenterTr661: 'to  7600',
      tableCenterTr662: 'to 38000',
      tableCenterTr663: 'to 76500',
      tableCenterTr664: 'to 150000',
      tableCenterTr665: 'to 230000',
      tableCenterTr666: 'to 300000',
      tableCenterTr667: 'to 380000',
      tableCenterTr671: 'to 250',
      tableCenterTr672: 'to 1000',
      tableCenterTr673: 'to 2600',
      tableCenterTr674: 'to 5200',
      tableCenterTr675: 'to 7500',
      tableCenterTr676: 'to 10500',
      tableCenterTr677: 'to 13000',
      tableCenterTr681: 'to 320',
      tableCenterTr682: 'to 1500',
      tableCenterTr683: 'to 3200',
      tableCenterTr684: 'to 6300',
      tableCenterTr685: 'to 9500',
      tableCenterTr686: 'to 12700',
      tableCenterTr687: 'to 15800',
      tableCenterTr691: 'to 28',
      tableCenterTr692: 'to 140',
      tableCenterTr693: 'to 280',
      tableCenterTr694: 'to 560',
      tableCenterTr695: 'to 830',
      tableCenterTr696: 'to 1100',
      tableCenterTr697: 'to 1400',
      tableCenterTr6101: 'to 170',
      tableCenterTr6102: 'to 830',
      tableCenterTr6103: 'to 1700',
      tableCenterTr6104: 'to 3300',
      tableCenterTr6105: 'to 5000',
      tableCenterTr6106: 'to 6700',
      tableCenterTr6107: 'to 8300',
      tableCenterTr6111: 'to 690000',
      tableCenterTr6112: 'to 3450000',
      tableCenterTr6113: 'to 6900000',
      tableCenterTr6114: 'to 13800000',
      tableCenterTr6115: 'to 20500000',
      tableCenterTr6116: 'to 27000000',
      tableCenterTr6117: 'to 34500000',
      tableCenterTr6121: 'to 85',
      tableCenterTr6122: 'to 430',
      tableCenterTr6123: 'to 850', 
      tableCenterTr6124: 'to 1700',
      tableCenterTr6125: 'to 2500',
      tableCenterTr6126: 'to 3400',
      tableCenterTr6127: 'to 4300',
      tableCenterTr6131: 'to 60',
      tableCenterTr6132: 'to 290',
      tableCenterTr6133: 'to 570', 
      tableCenterTr6134: 'to 1100',
      tableCenterTr6135: 'to 1800',
      tableCenterTr6136: 'to 2300',
      tableCenterTr6137: 'to 2900',
      tableCenterTr6141: 'to 182000',
      tableCenterTr6142: 'to 900000',
      tableCenterTr6143: 'to 1820000',
      tableCenterTr6144: 'to 3640000',
      tableCenterTr6145: 'to 5500000',
      tableCenterTr6146: 'to 730000',
      tableCenterTr6147: 'to 9000000',
      subParagraph131: '13.1. At least one outcome in a bet is made on a match or event not in the Promotion.',
      subParagraph132: '13.2. The bet was made using the free bet.',
      subParagraph133: '13.3. The bet has already been considered in other promotions of the company.',
      subParagraph134: '13.4. The bet was sold by the participant of the Action.',
      subParagraph135: '13.5. The Accumulator bet Multiplier function was used.',
      subParagraph141: 'а) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BC Zenit and for other participants and for third parties;',
      subParagraph142: 'b) in case of revealing the fact that the participant has provided information that does not correspond to reality; ',
      subParagraph143: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraph144: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraph145: "e) the Participant's account has been blocked.",
      subParagraph161: '16.1. The free bet can be made only for the entire amount of the free bet.',
      subParagraph162: '16.2. Free bet can be used within 7 days (168 hours) from the moment of its charging.',
    },
    ru: {
      siteTitle: "Турнир чемпионов",
      rulesBtnText: "Правила",
      title: `Турнир чемпионов`,
      subtitle: "Чемпионом может стать каждый",
      subtitlebig: "На кону 4 000 000 ₽",
      button: "НАЧАТЬ",
      stepTitle1: 'ШАГ 1',
      stepText1: 'Регистрируйся',
      step1Text1: ' или ',
      step1Span2: 'авторизуйся',
      step1Text4: ' на\u00A0сайте',
      stepTitle2: 'ШАГ 2',
      stepText2: `Делай ставки\n
      на чемпионат\u00A0мира`,
      stepTitle3: 'ШАГ 3',
      stepText3: `Обходи соперников
      и\u00A0выигрывай\u00A0фрибеты`,
      stepText1Mobile: 'Перейди в сторис и нажми ',
      step1Span2Mobile: 'кнопку УЧАСТВОВАТЬ',
      stepText2Mobile: `Делай ставки\xA0
      на чемпионат\u00A0мира`,
      stepText3Mobile: `Обходи соперников
      и\u00A0выигрывай\u00A0фрибеты`,
      bookmakerString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      supportText: "СЛУЖБА ПОДДЕРЖКИ:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: {
        main: "Правила участия в Акции\u00A0",
        span: "Турнир чемпионов"
      },
      level: "Уровень",
      totalPoints: "Сумма баллов",
      prizeSum: "Сумма Призов",
      currency: 'Валюта',
      place1: '1 место',
      place2: '2 место',
      place3: '3 место',
      dollar: 'Доллар',
      ruble: 'Рубль',
      hryvnia: 'Гривна',
      euro: 'Евро',
      tenge: 'Тенге',
      pmrRuble: 'руб. ПМР',
      moldovanLeu: 'Молдавский лей',
      azerbaijaniManat: 'Азербайджанский манат',
      tajikSomoni: 'Таджикский сомони',
      iranianRial: 'Иранский риал',
      brazilianReal: 'Бразильский реал',
      turkmenManat: 'Туркменский манат',
      uzbekSum: 'Узбекский сум',
      paragraph1: '1. Акция проводится с 20.11.2022 г. по 18.12.2022 г.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph31: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте ' ,
      paragraph3url: ` ${url},\u00A0`,
      paragraph32: 'а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. В период проведения Акции игроку начисляются баллы за ставки. В зачет Акции идут следующие ставки, кроме ставок на статистику:',
      paragraph5: '5. За все ставки из п. 4 Участнику Акции ежедневно начисляются баллы в количестве:',
      paragraph6: '6. В зависимости от количества набранных баллов Участникам присваивается один из 7 уровней. Размер приза зависит от уровня Участника. Для попадания на первый уровень Участнику необходимо набрать 100 баллов и больше.',
      paragraph7: '7. По итогам Акции Участники, которые наберут 100 баллов и больше, получают право один раз прокрутить рандомайзер, кроме участников, которые займут с 1 по 3 места. Рандомайзер определяет размер фрибета Участника (от 0 до максимального значения на уровне).  Фрибеты начисляются на следующий день после завершения Акции (19.12.2022).',
      paragraph8: '8. Участники, которые по итогам Акции займут с 1 по 3 место, получают фиксированные фрибеты: 3 место — 70000 рублей,  2 место — 100000 рублей,  1 место — от 150000 до 200000 рублей (если количество баллов меньше 150000, то сумма фрибета 150000 рублей; если сумма баллов выше 150000, то сумма фрибета равна количеству баллов, но не превышает 200000 рублей).',
      paragraph9: '9. Участники, которым доступен рандомайзер, могут воспользоваться им для определения размера приза до 20.12.2022.',
      paragraph10: '10. Если Участники набирают равное количество баллов и занимают одно место в турнирной таблице, то приоритет в таблице отдается Участнику, чья сумма ставок в период Акции была выше. Если сумма ставок равна, то Участники делят место в турнирной таблице, но при этом каждый из Участников получает приз, соответствующий занятому месту, в полном объеме. ',
      paragraph11: '11. Фрибеты будут начислены Участникам, у которых на момент подведения итогов Акции будет подтвержден номер телефона. Прокрутка рандомайзера также доступна только Участникам Акции с подтвержденным номером телефона. ',
      paragraph12: '12. Фрибет может быть использован в течение 7 дней (168 часов) с момента его зачисления.',
      paragraph13: '13. Баллы за ставки не начисляются в следующих случаях:',
      paragraph14: '14. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любых недобросовестных действий, но не ограничиваясь вышеперечисленным:',
      paragraph15: '15. В случае обнаружения любого из нарушений правил Акции БК «Зенит»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph16: '16. Условия использования фрибетов:',
      paragraph17: '17. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph18: '18. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph19: '19. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'минимальная сумма депозита',
      tableCenterTopText: 'максимальная сумма депозита',
      tableRightTopText:  'валюта',
      noFreebetText: 'бесплатная ставка не выдается',
      subparagraph41: '4.1. Ставки сделаны на чемпионат мира по футболу 2022:',
      subparagraph411: '- Футбол. Мир. ЧМ-2022. Групповой этап. Катар;',
      subparagraph412: '- Футбол. Итоги. Мир. ЧМ-2022. Победитель',
      subparagraph413: '- Футбол. Мир. ЧМ-2022. 1/8 финала. Катар;',
      subparagraph414: '- Футбол. Мир. ЧМ-2022. 1/4 финала. Катар;',
      subparagraph415: '- Футбол. Мир. ЧМ-2022. 1/2 финала. Катар;',
      subparagraph416: '- Футбол. Мир. ЧМ-2022. Матч за 3-е место. Катар;',
      subparagraph417: '- Футбол. Мир. ЧМ-2022. Финал. Катар.',
      subparagraph42: '4.2. Ставки типа ординар, экспресс и/или система, при этом все события в купоне экспресса и/или системы должны быть на чемпионат мира по футболу 2022.',
      subparagraph43: '4.3. Ставки, рассчитанные в период проведения Акции.',
      subparagraph44: '4.4. Ставки, рассчитанные со статусом «проигрыш» или «выигрыш».',
      subParagraph51: "5.1. Выигрышная ставка: сумма чистого выигрыша (эквивалент в рублях)*1%.",
      subParagraph52: "5.2. Проигрышная ставка: сумма ставки (эквивалент в рублях)*5%.",
      tableCenterTopText5: "Уровень",
      tableRightTopText5:  'Сумма баллов',
      tableRightTr5: 'от 0 до 99',
      tableLeftTr52: '1.Новичок',
      tableRightTr52: 'от 100 до 999',
      tableLeftTr53: '2.Любитель',
      tableRightTr53: 'от 1000 до 4999',
      tableLeftTr54: '3.Талант',
      tableRightTr54: 'от 5000 до 9999',
      tableLeftTr55: '4.Профи',
      tableRightTr55: 'от 10000 до 19999',
      tableLeftTr56: '5.Мастер',
      tableRightTr56: 'от 20000 до 29999',
      tableLeftTr57: '6.Легенда',
      tableRightTr57: 'от 30000 до 39999',
      tableLeftTr58: '7.Гуру',
      tableRightTr58: 'от 40000',
      tableCenterTr621: 'до 1000',
      tableCenterTr622: 'до 5000',
      tableCenterTr623: 'до 10000',
      tableCenterTr624: 'до 20000',
      tableCenterTr625: 'до 30000',
      tableCenterTr626: 'до 40000',
      tableCenterTr627: 'до 50000',
      tableCenterTr631: 'до 16',
      tableCenterTr632: 'до 80',
      tableCenterTr633: 'до 160',
      tableCenterTr634: 'до 320',
      tableCenterTr635: 'до 490',
      tableCenterTr636: 'до 650',
      tableCenterTr637: 'до 800',
      tableCenterTr641: 'до 600',
      tableCenterTr642: 'до 3000',
      tableCenterTr643: 'до 6000',
      tableCenterTr644: 'до 12000',
      tableCenterTr645: 'до 18000',
      tableCenterTr646: 'до 24000',
      tableCenterTr647: 'до 30000',
      tableCenterTr651: 'до 17',
      tableCenterTr652: 'до 82',
      tableCenterTr653: 'до 170',
      tableCenterTr654: 'до 330',
      tableCenterTr655: 'до 500',
      tableCenterTr656: 'до 670',
      tableCenterTr657: 'до 840',
      tableCenterTr661: 'до  7600',
      tableCenterTr662: 'до 38000',
      tableCenterTr663: 'до 76500',
      tableCenterTr664: 'до 150000',
      tableCenterTr665: 'до 230000',
      tableCenterTr666: 'до 300000',
      tableCenterTr667: 'до 380000',
      tableCenterTr671: 'до 250',
      tableCenterTr672: 'до 1000',
      tableCenterTr673: 'до 2600',
      tableCenterTr674: 'до 5200',
      tableCenterTr675: 'до 7500',
      tableCenterTr676: 'до 10500',
      tableCenterTr677: 'до 13000',
      tableCenterTr681: 'до 320',
      tableCenterTr682: 'до 1500',
      tableCenterTr683: 'до 3200',
      tableCenterTr684: 'до 6300',
      tableCenterTr685: 'до 9500',
      tableCenterTr686: 'до 12700',
      tableCenterTr687: 'до 15800',
      tableCenterTr691: 'до 28',
      tableCenterTr692: 'до 140',
      tableCenterTr693: 'до 280',
      tableCenterTr694: 'до 560',
      tableCenterTr695: 'до 830',
      tableCenterTr696: 'до 1100',
      tableCenterTr697: 'до 1400',
      tableCenterTr6101: 'до 170',
      tableCenterTr6102: 'до 830',
      tableCenterTr6103: 'до 1700',
      tableCenterTr6104: 'до 3300',
      tableCenterTr6105: 'до 5000',
      tableCenterTr6106: 'до 6700',
      tableCenterTr6107: 'до 8300',
      tableCenterTr6111: 'до 690000',
      tableCenterTr6112: 'до 3450000',
      tableCenterTr6113: 'до 6900000',
      tableCenterTr6114: 'до 13800000',
      tableCenterTr6115: 'до 20500000',
      tableCenterTr6116: 'до 27000000',
      tableCenterTr6117: 'до 34500000',
      tableCenterTr6121: 'до 85',
      tableCenterTr6122: 'до 430',
      tableCenterTr6123: 'до 850', 
      tableCenterTr6124: 'до 1700',
      tableCenterTr6125: 'до 2500',
      tableCenterTr6126: 'до 3400',
      tableCenterTr6127: 'до 4300',
      tableCenterTr6131: 'до 60',
      tableCenterTr6132: 'до 290',
      tableCenterTr6133: 'до 570', 
      tableCenterTr6134: 'до 1100',
      tableCenterTr6135: 'до 1800',
      tableCenterTr6136: 'до 2300',
      tableCenterTr6137: 'до 2900',
      tableCenterTr6141: 'до 182000',
      tableCenterTr6142: 'до 900000',
      tableCenterTr6143: 'до 1820000',
      tableCenterTr6144: 'до 3640000',
      tableCenterTr6145: 'до 5500000',
      tableCenterTr6146: 'до 730000',
      tableCenterTr6147: 'до 9000000',
      subParagraph131: '13.1. Хотя бы один исход в ставке сделан на матч или событие не из условий Акции.',
      subParagraph132: '13.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph133: '13.3. Ставка уже была учтена в других акциях компании.',
      subParagraph134: '13.4. Ставка была продана участником Акции. ',
      subParagraph135: '13.5. Была использована функция Множитель экспресса.',
      subParagraph141: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;',
      subParagraph142: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraph143: 'в) участник нарушает Правила Акции;',
      subParagraph144: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraph145: 'д) аккаунт участника Акции заблокирован.',
      subParagraph161: '16.1. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraph162: '16.2. Фрибет может быть использован в течение 7 дней (168 часов) с момента его начисления.',
    },
  },
  cupis: {
    ru: {
      siteTitle: "Турнир чемпионов",
      rulesBtnText: "Правила",
      title: `Турнир чемпионов`,
      subtitle: "Чемпионом может стать каждый",
      subtitlebig: "На кону 4 000 000 ₽",
      button: "НАЧАТЬ",
      stepTitle1: 'ШАГ 1',
      stepText1: 'Регистрируйся',
      step1Text1: ' или ',
      step1Span2: 'авторизуйся',
      step1Text4: ' на\u00A0сайте',
      stepTitle2: 'ШАГ 2',
      stepText2: `Делай ставки\n
      на чемпионат\u00A0мира`,
      stepTitle3: 'ШАГ 3',
      stepText3: `Обходи соперников
      и\u00A0выигрывай\u00A0фрибеты`,
      stepText1Mobile: 'Перейди в сторис и нажми ',
      step1Span2Mobile: 'кнопку УЧАСТВОВАТЬ',
      stepText2Mobile: `Делай ставки
      на чемпионат\u00A0мира`,
      stepText3Mobile: `Обходи соперников
      и\u00A0выигрывай\u00A0фрибеты`,
      bookmakerString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      supportText: "СЛУЖБА ПОДДЕРЖКИ:",
      supportSpan: "8 (800) 222-55-50",
      rulesHeaderText: {
        main: "Правила участия в Акции\u00A0",
        span: "Турнир чемпионов"
      },
      level: "Уровень",
      totalPoints: "Сумма баллов",
      prize: 'Приз',
      prizeSum: "Сумма Призов",
      paragraph1: '1. Акция проводится с 20.11.2022 г. по 18.12.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph31: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте ' ,
      paragraph3url: ` ${url},`,
      paragraph32: 'а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать». В Акции могут принимать участие только игроки, которые прошли упрощенную или полную идентификацию',
      paragraph4: '4. В период проведения Акции игроку начисляются баллы за ставки. В зачет Акции идут ставки, сделанные на Чемпионат мира по футболу-2022, кроме статистики, соответствующие указанному:',
      paragraph5: '5. За все ставки из п. 4 Участнику Акции ежедневно начисляются баллы в количестве:',
      paragraph6: '6. В зависимости от количества набранных баллов Участникам присваивается один из 7 уровней. Размер фрибета зависит от уровня Участника. Для попадания на первый уровень Участнику необходимо набрать 100 баллов и больше.',
      paragraph7: '7. По итогам Акции Участники, которые наберут 100 баллов и больше, получают право один раз прокрутить рандомайзер, кроме участников, которые займут с 1 по 3 места. Рандомайзер определяет размер фрибета Участника (от 0 до максимального значения на уровне).  Фрибеты начисляются на следующий день после завершения Акции (19.12.2022).',
      paragraph8: '8. Участники, которые по итогам Акции займут с 1 по 3 место, получают фиксированные фрибеты: 3 место — 70000 рублей,  2 место — 100000 рублей,  1 место — от 150000 до 200000 рублей (если количество баллов меньше 150000, то сумма фрибета 150000 рублей; если сумма баллов выше 150000, то сумма фрибета равна количеству баллов, но не превышает 200000 рублей)',
      paragraph9: '9. Участники, которым доступен рандомайзер, могут воспользоваться им для определения размера приза до 23:59 20.12.2022 GMT+3.',
      paragraph10: '10. Если Участники набирают равное количество баллов и занимают одно место в турнирной таблице, то приоритет в таблице отдается Участнику, чья сумма ставок в период Акции была выше. Если сумма ставок равна, то Участники делят место в турнирной таблице, но при этом каждый из Участников получает приз, соответствующий занятому месту, в полном объеме. ',
      paragraph11: '11. Фрибет может быть использован в течение 7 дней (168 часов) с момента его зачисления.',
      paragraph13: '12. Баллы за ставки не начисляются в следующих случаях:',
      paragraph14: '13. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любых недобросовестных действий, но не ограничиваясь вышеперечисленным:',
      paragraph15: '14. В случае обнаружения любого из нарушений правил Акции БК «Зенит»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph16: '15. Условия использования фрибетов:',
      paragraph17: '16. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph18: '17. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      paragraph20: 'Словарь терминов',
      tableLeftTopText: 'минимальная сумма депозита',
      tableCenterTopText: 'максимальная сумма депозита',
      tableRightTopText:  'валюта',
      noFreebetText: 'бесплатная ставка не выдается',
      subparagraph41: '4.1. Ставки сделаны на:',
      subparagraph411: '- Футбол. Мир. ЧМ-2022. Групповой этап. Катар;',
      subparagraph412: '- Футбол. Итоги. Мир. ЧМ-2022. Победитель',
      subparagraph413: '- Футбол. Мир. ЧМ-2022. 1/8 финала. Катар;',
      subparagraph414: '- Футбол. Мир. ЧМ-2022. 1/4 финала. Катар;',
      subparagraph415: '- Футбол. Мир. ЧМ-2022. 1/2 финала. Катар;',
      subparagraph416: '- Футбол. Мир. ЧМ-2022. Матч за 3-е место. Катар;',
      subparagraph417: '- Футбол. Мир. ЧМ-2022. Финал. Катар.',
      subparagraph42: '4.2. Ставки типа ординар, экспресс и/или система, при этом все события в купоне экспресса и/или системы должны быть на чемпионат мира по футболу 2022.',
      subparagraph43: '4.3. Ставки, рассчитанные в период проведения Акции.',
      subparagraph44: '4.4. Ставки, рассчитанные со статусом «проигрыш» или «выигрыш».',
      subParagraph51: "5.1. Выигрышная ставка: сумма чистого выигрыша (эквивалент в рублях)*1%.",
      subParagraph52: "5.2. Проигрышная ставка: сумма ставки (эквивалент в рублях)*5%.",
      tableCenterTopText5: "Уровень",
      tableRightTopText5:  'Сумма баллов',
      tableRightTr5: 'от 0 до 99',
      tableLeftTr52: '1.Новичок',
      tableRightTr52: 'от 100 до 999',
      tableLeftTr53: '2.Любитель',
      tableRightTr53: 'от 1000 до 4999',
      tableLeftTr54: '3.Талант',
      tableRightTr54: 'от 5000 до 9999',
      tableLeftTr55: '4.Профи',
      tableRightTr55: 'от 10000 до 19999',
      tableLeftTr56: '5.Мастер',
      tableRightTr56: 'от 20000 до 29999',
      tableLeftTr57: '6.Легенда',
      tableRightTr57: 'от 30000 до 39999',
      tableLeftTr58: '7.Гуру',
      tableRightTr58: 'от 40000',
      subParagraph131: '12.1. Хотя бы один исход в ставке сделан на матч или событие не из условий Акции.',
      subParagraph132: '12.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph133: '12.3. Ставка уже была учтена в других акциях компании.',
      subParagraph134: '12.4 Ставка была продана участником Акции.',
      subParagraph135: '12.5 Была использована функция Множитель экспресса.',
      subParagraph141: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и/или для третьих лиц;',
      subParagraph142: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraph143: 'в) участник нарушает Правила Акции;',
      subParagraph144: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraph145: 'д) аккаунт участника Акции заблокирован.',
      subParagraph161: '15.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 4 настоящих Правил, в течение 7 дней.',
      subParagraph162: '15.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraph201: 'Баллы — единица измерения активности Участников Акции в период проведения Акции. Баллы начисляются согласно п.5 настоящих Правил.',
      subParagraph202: 'Фрибет — это бесплатная ставка, которую Участник Акции может использовать для заключения пари.',
    },
  }
}

